angular
    .module('pipAppBar', ['ngMaterial', 'pipNav.Templates']);

import './AppBarConfig';
import './AppBarService';
import './AppBar';
import './AppBarPart';

export * from './AppBarService';
